import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@platform/base';
import CompMeta from '../../meta/LowCodeComponents/Checkbox';
/**
 * @class NCCheckbox
 * @column 1
 * @compType 1
 * @canAppend false
 * @path LowCodeComponents.NCCheckbox
 * @label 多选
 *
 */
class NCCheckbox extends Component {
    constructor(props) {
        super(props);
    }
    static propTypes = {
        /**
        * @title 区域编码
        * @description 组件标识
        */
        moduleId: PropTypes.string.isRequired,
        /**
         * @title className
         * @description 样式
         */
        className: PropTypes.string,
        /**
         * @title 自动化Id
         * @description 自动化Id
         */
        fieldid: PropTypes.string,
        /**
         * @title 类型
         * @description 类型
         */
        type: PropTypes.string,
        /**
        * @title 选中
        * @description 选中
        */
        checked: PropTypes.bool
    }
    static getCompMeta = () => {
        return CompMeta;
    }
    render() {
        return (
            <Checkbox {...this.props} >{this.props.children}</Checkbox>
        )
    }
}

export default NCCheckbox;
